import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaymentPending = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [timeElapsed, setTimeElapsed] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const details = {
      transactionId: params.get('transactionId') || 'PND' + Date.now(),
      amount: params.get('amount') || '0',
      planName: params.get('planName') || 'Premium Plan',
      members: params.get('members') || '1',
      paymentMethod: params.get('paymentMethod') || 'Bank Transfer'
    };
    setPaymentDetails(details);

    const timer = setInterval(() => {
      setTimeElapsed(prev => prev + 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [location]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        maxWidth: '600px',
        backgroundColor: 'white',
        borderRadius: '16px',
        padding: '40px',
        textAlign: 'center',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          backgroundColor: '#ff9800',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px'
        }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
            <path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z"/>
          </svg>
        </div>

        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '700',
          color: '#ff9800',
          marginBottom: '16px'
        }}>
          Payment Pending ⏳
        </h1>

        <p style={{
          fontSize: '1.2rem',
          color: '#666',
          marginBottom: '30px'
        }}>
          Your payment is being processed. Please wait...
        </p>

        <div style={{
          backgroundColor: '#fff3e0',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '30px'
        }}>
          <p style={{ margin: '0', fontSize: '1.1rem', color: '#f57c00' }}>
            ⏱️ Processing time: <strong>{formatTime(timeElapsed)}</strong>
          </p>
        </div>

        {paymentDetails && (
          <div style={{
            backgroundColor: '#f8f9fa',
            borderRadius: '12px',
            padding: '24px',
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h3 style={{ textAlign: 'center', marginBottom: '20px' }}>Transaction Details</h3>
            
            <div style={{ display: 'grid', gap: '12px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Transaction ID:</span>
                <span style={{ fontWeight: '600' }}>{paymentDetails.transactionId}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Plan:</span>
                <span style={{ fontWeight: '600' }}>{decodeURIComponent(paymentDetails.planName)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span>Members:</span>
                <span style={{ fontWeight: '600' }}>{paymentDetails.members}</span>
              </div>
              <hr />
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '1.2rem' }}>
                <span style={{ fontWeight: '600' }}>Amount:</span>
                <span style={{ fontWeight: '700', color: '#ff9800' }}>₹{paymentDetails.amount}</span>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={() => console.log('Checking status...')}
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: '#ff9800',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1.1rem',
            fontWeight: '600',
            cursor: 'pointer',
            marginBottom: '20px'
          }}
        >
          🔄 Check Status
        </button>

        <div style={{
          backgroundColor: '#fff9c4',
          borderRadius: '8px',
          padding: '16px'
        }}>
          <p style={{ margin: '0', color: '#f57f17', fontSize: '0.9rem' }}>
            💡 <strong>Tip:</strong> Bank transfers take 2-5 minutes. UPI payments are instant.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentPending;